import type { AppRouteRecordRaw } from "../types/types";

import { RouteNames } from "@/app/router/types/names";
import { Permissions, PermissionGroups } from "@/shared/constants";

const productRatingAndReviewsRoutes: AppRouteRecordRaw[] = [
  {
    path: "/reviews",
    name: "reviews-parent",
    redirect: "/reviews/rating",
    meta: {
      menuIcon: "lucide:message-square-text",
      menuTitle: "Ratings & Reviews",
      isMenuParent: true,
      permissions: PermissionGroups.PRODUCT_REVIEWS,
    },
    children: [
      {
        path: "rating",
        name: RouteNames.REVIEWS,
        component: () => import("@/pages/RatingAndReview/RatingAndReviews.vue"),
        meta: {
          pageKey: "RatingAndReviews",
          title: "Rating & Reviews",
          menuIcon: "lucide:star",
          permissions: [Permissions.REVIEW_REPORT],
        },
      },
      {
        path: "product-reviews",
        name: RouteNames.PRODUCT_REVIEWS,
        component: () => import("@/pages/RatingAndReview/ProductReview.vue"),
        meta: {
          pageKey: "ProductReviews",
          title: "Product Reviews Uploader",
          menuTitle: "Reviews",
          menuIcon: "lucide:upload",
          permissions: [Permissions.PRODUCT_REVIEWS],
          filters: {
            show: ["brands"],
          },
        },
      },
    ],
  },

];

export default productRatingAndReviewsRoutes;
